import { HTMLProps, Ref } from 'react';

interface Props extends HTMLProps<HTMLInputElement> {
  error?: boolean;
  innerRef?: Ref<HTMLInputElement>;
}

export default function Input({ error = false, className = '', innerRef, ...others }: Props) {
  return (
    <input
      className={`p-1 h-10 w-full border-2 rounded-md bg-slate-50 focus:border-primary-600 outline-none
      ${error ? 'border-red-400' : 'border-primary-400'} ${className}`}
      ref={innerRef}
      {...others}
    />
  );
}
